import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  container: {
    maxWidth: "640px",
  },
  modalTitle: {
    marginTop: 40,
    marginBottom: 16,
    fontWeight: 400,
    textAlign: "center",
  },
  modalSubtitle: {
    marginBottom: 16,
  },
  containerLegend: {
    marginBottom: 16,
  },
  greenPoint: {
    marginTop: 6,
    borderRadius: 50,
    width: "8px",
    height: "8px",
    backgroundColor: "#00F69E",
  },
  legendText: {
    marginLeft: 16,
    maxWidth: "513px",
  },
  fileInput: {
    display: "none",
  },
}));

export default useStyles;
